'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function () {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            def: '=?myDef'
        },
        controller: ['$scope', '$utils', 'StatusService', 'Notification', '$security', 'StaffService', 'ModalService',
            function ($scope, $utils, StatusService, Notification, $security, StaffService, ModalService) {

                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.getStatusDisplayName = StatusService.getDisplayName;

                // инициализация
                init();

                // region Function

                function init() {

                    $scope.loading = true;

                    $scope.columns = [{
                        name: "Код",
                        data: "id"
                    }, {
                        name: "Ф.И.О.",
                        data: "fullName"
                    }, {
                        name: "Должность",
                        data: "position"
                    }, {
                        name: "Организация",
                        data: "org.shortName"
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    // тулбокс таблицы
                    $scope.toolbox = {
                        // кнопки на панели управления
                        buttons: {
                            // создание
                            create: {
                                show: () => $security.isAllowWrite('/staffs'),
                                click: () => StaffService.create($scope.def).result.then((data) =>
                                    StaffService.api.create(null, {"form": data}, (data) => {
                                        $scope.selectedItem = data._embedded;
                                        $scope.items.push(data._embedded);
                                        $scope.refresh();
                                    })
                                ),
                                disabled: () => false,
                            },
                            // редактирование
                            edit: {
                                show: () => isSelected(),
                                click: (item) => {
                                    StaffService.edit(item).result.then(function (data) {
                                        StaffService.api.update({staffId: data.id}, {"form": data}, (data) => {
                                            angular.copy(data._embedded, item);
                                            $scope.refresh();
                                        });
                                    });
                                },
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            // удаление
                            remove: {
                                show: () => isSelected() && $security.isAllowWrite('/staffs'),
                                click: (item) => {

                                    ModalService.danger({
                                        message: "Запись будет удалена без возможности восстановления! Вы действительно желаете удалить данную запись?",
                                        apply: "Да",
                                        cancel: "Нет"
                                    }).result.then(() => {

                                            // if (item.existUser) {
                                            //     Notification.warning({
                                            //         title: "Внимание!",
                                            //         message: 'Данную запись удалить нельзя.<br />Сначала открепите пользователя от записи.',
                                            //     });
                                            //     return;
                                            // }

                                            StaffService.api.remove({staffId: item.id}, (data) => {

                                                if (data.code === 200) {
                                                    $scope.items.splice($scope.items.indexOf(item), 1);
                                                    $scope.refresh();

                                                    Notification.success({
                                                        message: 'Сотрудник удален!',
                                                    });

                                                    return;
                                                }

                                                Notification.warning({
                                                    title: "Внимание!",
                                                    message: 'Данную запись удалить нельзя,<br />т.к. на нее ссылаются записи других таблиц.',
                                                });

                                            }, (error) => {
                                                Notification.warning({
                                                    title: "Внимание!",
                                                    message: 'Данную запись удалить нельзя,<br />т.к. на нее ссылаются записи других таблиц.',
                                                });
                                            });
                                        }
                                    );
                                },
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            // обновление таблицы
                            refresh: {
                                show: () => true,
                                click: $scope.refresh,
                                disabled: () => false,
                            }
                        }
                    };

                    // получение данных
                    refresh();
                }

                /**
                 * Получение всех записей
                 * @returns {*}
                 */
                function getItems() {
                    return $scope.items;
                }

                /**
                 * Выбран ли элемент!
                 * @param item проверяемый элемент
                 * @returns bool
                 */
                function isSelect(item) {
                    return equals(getSelected(), item);
                }

                /**
                 * Выбрать элемент
                 * @param item выбираемый элемент
                 */
                function select(item) {
                    if (!$scope.isSelect(item)) {
                        $scope.selectedItem = angular.copy(item);
                    } else {
                        $scope.selectedItem = angular.copy({});
                    }
                }

                /**
                 * Двойное нажатие на запись в таблице
                 * @param item данные записи
                 */
                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select' :
                            $scope.ok(item);
                            break;
                    }
                }

                /**
                 * Получение фильтров
                 * @returns {Array}
                 */
                function getFilters() {
                    let filters = [];
                    if (Array.isArray($scope.filters)) {
                        filters = filters.concat($scope.filters);
                    }
                    if ($scope.filter != null && $scope.filter.org != null) {
                        filters.add("'org.id' EQ '" + $scope.filter.org + "'");
                    }
                    return filters;
                }

                /**
                 * Получение поиска
                 * @returns {Array}
                 */
                function getSearchs() {
                    let searchs = [];
                    if ($scope.isSearch) {
                        if ($scope.searching.filter != null && !($scope.searching.filter.length < 1)) {
                            searchs.push("'surname':'" + $scope.searching.filter + "'",
                                "'firstName':'" + $scope.searching.filter + "'",
                                "'middleName':'" + $scope.searching.filter + "'",
                                "'position':'" + $scope.searching.filter + "'",
                                "'phone':'" + $scope.searching.filter + "'",
                                "'fax':'" + $scope.searching.filter + "'",
                                "'email':'" + $scope.searching.filter + "'",
                                "'skype':'" + $scope.searching.filter + "'");
                        }
                    }
                    return searchs;
                }

                /**
                 * Выбрана ли запись
                 * @returns {boolean}
                 */
                function isSelected() {
                    return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                }

                /**
                 * Проверка элементов на равенство
                 * @param i1
                 * @param i2
                 * @returns {*}
                 */
                function equals(i1, i2) {
                    if (i1 == i2) {
                        return true;
                    }
                    if (i1 != null && i2 != null) {
                        return angular.equals(i1.id, i2.id);
                    }
                    return false;
                }

                /**
                 * Получить выбранный элемент
                 * @returns {{}|*}
                 */
                function getSelected() {
                    return $scope.selectedItem;
                }

                /**
                 * Обновить данные таблицы
                 */
                function refresh() {
                    $scope.loading = true;
                    StaffService.api.get({
                        filters: getFilters(),
                        searchs: getSearchs(),
                        sorts: ['surname:ASC', 'firstName:ASC', 'middleName:ASC'],
                        page: $scope.pagination.page,
                        size: $scope.pagination.size
                    }, function (data) {
                        $scope.items = data._embedded;
                        if (isSelected()) {
                            if ($scope.items.every(i => !equals(i, getSelected()))) {
                                $scope.selectedItem = {};
                            } else {
                                $scope.selectedItem = angular.copy($scope.items.find(i => equals(i, getSelected())));
                            }
                        }
                        if ($scope.pagination.isPaging) {
                            $scope.pagination.totalPages = data.page.totalPages;
                            $scope.pagination.totalItems = data.page.totalElements;
                        }
                        $scope.loading = false;
                    });
                }

                // endregion

                // region Watchers

                $scope.$watch('filters', function () {
                    $scope.refresh();
                });

                // endregion

            }]
    };
}
